import { estates } from './endpoints'
import { authCall } from '.'
import { ResidentTypeReq, ResidentTypeResponse } from '../interfaces/resident'

const ResidentTypeService = {
  // getResidentTypeList: async ({ page = 1, size = 15, all = false }) => {
  //   const url = all
  //     ? `${residentType}?all=true`
  //     : `${residentType}?page=${page}&size=${size}`
  //   return authCall<PaginatedResidentTypes>({
  //     url,
  //     method: 'get',
  //   })
  // },

  getResidentType: ({
    estateId,
    page = 1,
    limit = 10,
    all = false,
  }: ResidentTypeReq) => {
    const url = `${estates}/${estateId}/resident-types?page=${page}&limit=${limit}&all=${all}`;
      return authCall<ResidentTypeResponse>({
        url,
        method: 'get',
      });
  },
}

  // residentType: (data: ResidentTypes) => {
  //   const url = residentTypes;
  //   return authCall<PaginatedResidentTypes>({
  //     url,
  //     data,
  //     method: "get",
  //   });
  // },


export default ResidentTypeService
